import { merchantReducer } from './merchant.reducer';
import { userReducer } from './user.reducer';

export default {
  merchant: merchantReducer,
  user: userReducer,
}